<!-- src/views/management/PartnerControl.vue -->
<template>
  <v-container fluid>
    <v-tabs v-model="tab">
      <v-tab>Заявки на выплаты</v-tab>
      <v-tab>Рефералы</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- Заявки на выплаты -->
      <v-tab-item>
        <v-data-table :headers="payoutHeaders" :items="requests" :items-per-page="15">
          <template v-slot:item.amount="{ item }">{{ item.amount | toCurrency }}</template>
          <template v-slot:item.dateCreated="{ item }">{{ new Date(item.dateCreated).toLocaleString() }}</template>
          <template v-slot:item.actions="{ item }">
            <v-btn v-if="item.status === 0" x-small color="success" class="mr-1" @click="SetStatus(item, 1)">
              Подтвердить
            </v-btn>
            <v-btn v-if="item.status === 1" x-small color="info" class="mr-1" @click="SetStatus(item, 2)">
              В бухгалтерию
            </v-btn>
            <v-btn v-if="item.status === 2" x-small color="primary" class="mr-1" @click="SetStatus(item, 3)">
              Выплачена
            </v-btn>
            <v-btn v-if="item.status === 0 || item.status === 1" x-small color="error" @click="OpenReject(item)">
              Отклонить
            </v-btn>
          </template>
        </v-data-table>
      </v-tab-item>

      <!-- Рефералы -->
      <v-tab-item>
        <v-data-table
          :headers="referalHeaders"
          :items="referals"
          :items-per-page="15"
          :item-class="(item) => (item.isRetentionDue ? 'orange lighten-4' : '')"
        >
          <template v-slot:item.loginDateCreated="{ item }">
            {{ new Date(item.loginDateCreated).toLocaleDateString() }}
          </template>
          <template v-slot:item.retentionDueDate="{ item }">
            {{ new Date(item.retentionDueDate).toLocaleDateString() }}
          </template>
          <template v-slot:item.paymentSum="{ item }">
            {{ item.paymentSum != null ? $options.filters.toCurrency(item.paymentSum) : "—" }}
          </template>
          <template v-slot:item.state="{ item }">
            <span v-if="!item.paymentSum" class="grey--text">нет оплаты (ограничить доступ?)</span>
            <span v-else-if="item.isRetentionDue" class="orange--text">90 дней прошло — обновить сумму</span>
            <span v-else-if="item.hasRetentionAccrual" class="green--text">начислено 15%</span>
            <span v-else class="green--text">начислено 10%</span>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <!-- Отклонение с комментарием -->
    <v-dialog v-model="rejectDialog" max-width="480">
      <v-card>
        <v-card-title>Отклонить заявку №{{ rejectItem && rejectItem.id }}</v-card-title>
        <v-card-text>
          <v-textarea v-model="rejectComment" label="Комментарий (обязателен)" rows="3"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="rejectDialog = false">Отмена</v-btn>
          <v-btn color="error" :disabled="!rejectComment" @click="Reject">Отклонить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "PartnerControl",
  data: () => ({
    tab: 0,
    requests: [],
    referals: [],
    rejectDialog: false,
    rejectItem: null,
    rejectComment: "",
    payoutHeaders: [
      { text: "№", value: "id" },
      { text: "Дата", value: "dateCreated" },
      { text: "Партнёр", value: "rpLogin" },
      { text: "ФИО", value: "rpName" },
      { text: "Сумма", value: "amount" },
      { text: "Статус", value: "statusName" },
      { text: "Комментарий", value: "managerComment" },
      { text: "Действия", value: "actions", sortable: false },
    ],
    referalHeaders: [
      { text: "Партнёр", value: "rpLogin" },
      { text: "Код", value: "referalCode" },
      { text: "Реферал (логин)", value: "login" },
      { text: "Аптека", value: "pharmacyName" },
      { text: "Дата логина", value: "loginDateCreated" },
      { text: "90 дней", value: "retentionDueDate" },
      { text: "Сумма", value: "paymentSum" },
      { text: "Состояние", value: "state", sortable: false },
    ],
  }),
  created() {
    this.Load();
  },
  methods: {
    async Load() {
      this.requests = await this.$store.dispatch("GET_ALL_PAYOUT_REQUESTS");
      this.referals = await this.$store.dispatch("GET_ALL_PARTNER_REFERALS");
    },
    async SetStatus(item, status) {
      try {
        await this.$store.dispatch("SET_PAYOUT_STATUS", { requestId: item.id, status, comment: null });
      } catch (err) {
        window.console.log(err);
      } finally {
        await this.Load();
      }
    },
    OpenReject(item) {
      this.rejectItem = item;
      this.rejectComment = "";
      this.rejectDialog = true;
    },
    async Reject() {
      try {
        await this.$store.dispatch("SET_PAYOUT_STATUS", {
          requestId: this.rejectItem.id, status: -1, comment: this.rejectComment,
        });
      } catch (err) {
        window.console.log(err);
      } finally {
        this.rejectDialog = false;
        await this.Load();
      }
    },
  },
};
</script>
